import * as o from "react";
import e from "../lib/IconBase.es.js";
import s from "../defs/ChatTeardropDots.es.js";
const r = o.forwardRef((t, a) => /* @__PURE__ */ o.createElement(e, { ref: a, ...t, weights: s }));
r.displayName = "ChatTeardropDotsIcon";
const c = r;
export {
  c as ChatTeardropDots,
  r as ChatTeardropDotsIcon
};
